import type { ReactNode } from 'react';
import { usePlanningPermissions } from '../usePlanningPermissions';
import { CONFIG } from '../config';
import { TokenChip } from '../TokenPurse';

export function SimpleShell({ children }: { children: ReactNode }) {
  const { can } = usePlanningPermissions();
  const isAdmin = can('policy-inputs:read') || can('planning-settings:read') || can('users:read');
  // The account icon toggles: on the Account page it takes you back to your assessments.
  const onAccount = window.location.hash.startsWith('#/account');
  return (
    <div className="sx-root">
      <header className="sx-bar">
        <img className="sx-bar-logo" src="./assets/elw-logo.png" alt="ELW" />
        <a className="sx-bar-name" href="#/assess" style={{ color: 'inherit', textDecoration: 'none' }}>Elevations Planning</a>
        {CONFIG.environment && <span className="sx-bar-env">{CONFIG.environment}</span>}
        <span className="sx-bar-sp" />
        <TokenChip />
        {isAdmin && (
          <a className="sx-bar-btn" href="#/cases" aria-label="Settings" title="Settings">
            <svg viewBox="0 0 24 24" fill="none" width="19" height="19" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="3" />
              <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h0a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51h0a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v0a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
            </svg>
          </a>
        )}
        <a className="sx-bar-btn" href={onAccount ? '#/assess' : '#/account'} aria-label={onAccount ? 'Back to my assessments' : 'Your account'} title={onAccount ? 'Back to my assessments' : 'Your account'} aria-current={onAccount ? 'page' : undefined}>
          <svg viewBox="0 0 24 24" fill="none" width="19" height="19" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="8" r="4" />
            <path d="M4 21a8 8 0 0 1 16 0" />
          </svg>
        </a>
      </header>
      <main className="sx-main">{children}</main>
    </div>
  );
}
